import script from "./headlogin.vue?vue&type=script&setup=true&lang=js"
export * from "./headlogin.vue?vue&type=script&setup=true&lang=js"

import "./headlogin.vue?vue&type=style&index=0&id=013c6925&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013c6925"]])

export default __exports__